import { useEffect } from 'react'
import { DomainType } from '../model'

export const useDomainTheme = () => {
  useEffect(() => {
    const hostname = window.location.hostname

    const getDomainType = (hostname: string): DomainType => {
      if (hostname.includes('payx')) {
        return 'payx'
      }
      if (hostname.includes('yellowpay')) {
        return 'yellowpay'
      }
      return 'syncra'
    }

    const domainType = getDomainType(hostname)

    // Устанавливаем атрибут data-domain для стилей
    document.documentElement.setAttribute('data-domain', domainType)

    // Меняем title страницы
    document.title =
      domainType === 'payx' ? 'Payx' :
      domainType === 'yellowpay' ? 'YellowPay' :
      'Syncra'

    // Меняем favicon
    const updateFavicon = (domain: DomainType) => {
      const prefix =
        domain === 'payx' ? 'payx-' :
        domain === 'yellowpay' ? 'yellowpay-' :
        ''

      // Обновляем все favicon ссылки
      const iconLinks = document.querySelectorAll('link[rel*="icon"]')
      iconLinks.forEach((link) => {
        const href = link.getAttribute('href')
        if (href) {
          // Удаляем старый префикс если есть
          const cleanHref = href
            .replace(/^\/payx-/, '/')
            .replace(/^\/yellowpay-/, '/')
          // Добавляем новый префикс если нужен
          link.setAttribute('href', `/${prefix}${cleanHref.substring(1)}`)
        }
      })

      // Обновляем apple-touch-icon
      const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]')
      if (appleTouchIcon) {
        appleTouchIcon.setAttribute('href', `/${prefix}apple-touch-icon.png`)
      }

      // Обновляем manifest
      const manifestLink = document.querySelector('link[rel="manifest"]')
      if (manifestLink) {
        manifestLink.setAttribute('href',
          domain === 'payx' ? '/payx-site.webmanifest' :
          domain === 'yellowpay' ? '/yellowpay-site.webmanifest' :
          '/site.webmanifest'
        )
      }

      // Обновляем meta name для Apple
      const appleMetaName = document.querySelector('meta[name="apple-mobile-web-app-title"]')
      if (appleMetaName) {
        appleMetaName.setAttribute('content',
          domain === 'payx' ? 'Payx' :
          domain === 'yellowpay' ? 'YellowPay' :
          'Syncra'
        )
      }
    }

    updateFavicon(domainType)

    // Cleanup функция для удаления атрибутов при размонтировании
    return () => {
      document.documentElement.removeAttribute('data-domain')
    }
  }, [])
}
